import { styled as i, css as s } from "./styled2.mjs";
import { InputLabel as o } from "./index46.mjs";
import { TextField as p, inputBaseClasses as e, inputLabelClasses as l, selectClasses as r } from "@mui/material";
const g = i(o)`
	color: ${({ theme: t }) => t.deprecated.tokens.stennGrey};
	padding-bottom: ${({ theme: t }) => t.tokens.spacing[2]};
`, c = i(p)`
	.${e.input} {
		height: unset;
		text-overflow: ellipsis;
	}

	.${l.shrink} {
		transform-origin: center left;
	}

	.${e.root} {
		height: ${({ theme: t, $size: n }) => n === "small" ? t.spacing(4.5) : t.spacing(6.5)};

		.${r.select} {
			${({ $size: t }) => {
  if (t === "small")
    return s`
						padding-top: 8px;
						padding-bottom: 5px;
					`;
  if (t === "medium")
    return s`
						padding-top: 15.5px;
						padding-bottom: 13.5px;
					`;
}};
		}
	}

	.${e.multiline} {
		height: unset;
		padding-block: unset;
	}
`;
export {
  g as OverLabel,
  c as StyledMuiTextField
};
//# sourceMappingURL=styles34.mjs.map
